module.exports = __webpack_public_path__ + "img/creative-commons-nc-eu.e1cc58f1.svg";